import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AppService } from "src/app/app.service";
import { forkJoin } from "rxjs";
import Utility from "src/app/utils/utility";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-image-folder",
  templateUrl: "./image-folder.component.html",
  styleUrls: ["./image-folder.component.scss"],
})
export class ImageFolderComponent implements OnInit {
  album: any[] = [];
  files: any[] = [];
  folders: any[] = [];
  albumData: any = null;
  mainResponse: any[] = [];
  imageLoaded = false;
  folderId: string | null = null;
  fetchingData = true;
  selectedItem: string = "photos";

  // Modal Logic State
  isModalOpen = false;
  currentIndex = 0;

  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private router: Router,
    public sanitizer: DomSanitizer
  ) {}



  loadFolder(folderId: string) {
  const id = +folderId; // convert string to number
  this.appService.getImageAlbumsById(id).subscribe({
    next: (res) => { this.albumData = res; },
    error: (err) => { console.error(err); }
  });
}


  ngOnInit(): void {
    console.log("🔄 ngOnInit Called");
    
    this.route.paramMap.subscribe((params: ParamMap) => {
      const folderId = params.get("folderId");
      console.log("📁 Route Param folderId:", folderId);
      
      if (folderId) {
        this.FetchAlbumById(folderId);
      } else {
        console.warn("⚠️ No folderId found in route");
      }
    });
  }

  FetchAlbumById(folderId: string): void {
    console.log("🚀 FetchAlbumById Started with:", folderId);
    this.fetchingData = true;

    forkJoin([
      this.appService.getImageAlbumsById(+folderId),
      this.appService.getImageFolders(),
    ]).subscribe({
      next: (response: any) => {
        console.log("📦 COMPLETE API Response:", response);
        
        // ✅ DEEP DEBUG: Check the actual structure
        if (response[0] && response[0].data) {
          console.log('🔍 response[0].data:', response[0].data);
          
          if (response[0].data.length > 0) {
            const firstItem = response[0].data[0];
            console.log('🔍 FIRST ITEM IN RAW API DATA:', firstItem);
            console.log('🔍 ALL KEYS in first item:', Object.keys(firstItem));
            
            // Check for ANY image-related fields
            const imageFields = Object.keys(firstItem).filter(key => 
              key.toLowerCase().includes('image') || 
              key.toLowerCase().includes('thumb') ||
              key.toLowerCase().includes('path') ||
              key.toLowerCase().includes('link') ||
              key.toLowerCase().includes('photo') ||
              key.toLowerCase().includes('pic') ||
              key.toLowerCase().includes('url')
            );
            
            console.log('🔍 IMAGE-RELATED FIELDS FOUND:', imageFields);
            console.log('🔍 VALUES of image fields:', 
              imageFields.reduce<Record<string, unknown>>((acc, field) => {
                acc[field] = firstItem[field];
                return acc;
              }, {})
            );
          }
        }

        this.mainResponse = Utility.TransformFolder_Data(response[0].data);
        console.log("🔄 Transformed mainResponse:", this.mainResponse);

        // Show album folders in reverse (last in, first shown)
        this.album = this.mainResponse
          .filter((item) => item.IsAlbumFolder === true)
          .reverse();

        this.files = this.mainResponse.filter(
          (item) => item.IsAlbumFolder === false
        );

        // ✅ Check what we actually got after transformation
        console.log('🔍 AFTER TRANSFORMATION - Checking first album:');
        if (this.album.length > 0) {
          const firstAlbum = this.album[0];
          console.log('🔍 First album ALL fields:', Object.keys(firstAlbum));
          console.log('🔍 First album image fields:', 
            Object.keys(firstAlbum).filter(key => 
              key.toLowerCase().includes('image') || 
              key.toLowerCase().includes('thumb') ||
              key.toLowerCase().includes('path') ||
              key.toLowerCase().includes('link')
            ).reduce<Record<string, unknown>>((acc, field) => {
              acc[field] = firstAlbum[field];
              return acc;
            }, {})
          );
        }

        const folderIdParam = this.route.snapshot.paramMap.get("folderId") === "null" 
          ? null 
          : this.route.snapshot.paramMap.get("folderId");

        this.folders = Utility.Transfrom_Folder(response[1].data, folderIdParam);
        this.fetchingData = false;
        
        console.log("✅ Data loaded - Albums:", this.album.length, "Files:", this.files.length);
      },
      error: (error) => {
        console.error('❌ Error fetching data:', error);
        this.fetchingData = false;
      }
    });
  }

  TransformUrl(value: string): SafeResourceUrl {
    if (!value) {
      console.warn('⚠️ Empty value provided to TransformUrl');
      return '';
    }

    console.log("🌐 TransformUrl input:", value);

    // If it's already a full URL, use it directly
    if (value.startsWith("http://") || value.startsWith("https://")) {
      console.log("✅ Using full URL directly");
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    } 
    // If it's an S3 path, construct the full URL
    else if (value.startsWith("dws/")) {
      const fullUrl = `https://acps-c53.s3.us-east-2.amazonaws.com/${value}`;
      console.log("🔗 Constructed S3 URL:", fullUrl);
      return this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
    }
    // For any other cases
    else {
      console.log("❓ Unknown URL format, adding https://");
      return this.sanitizer.bypassSecurityTrustResourceUrl(`https://${value}`);
    }
  }

  onImageError(event: any, album: any): void {
    console.error('❌ Image failed to load for album:', album?.Name);
    console.error('❌ Error event:', event);
    console.error('❌ Album image data:', {
      titleImagePath: album?.titleImagePath,
      titleImageLink: album?.titleImageLink,
      displayImageUrl: album?.displayImageUrl,
      finalUrl: event.target.src
    });
    
    // Try to use thumbnail as fallback if title image fails
    const fallbackUrl = album?.thumbnailLink || album?.thumbnailPath;
    if (fallbackUrl && event.target) {
      console.log('🔄 Trying fallback thumbnail URL:', fallbackUrl);
      event.target.src = this.TransformUrl(fallbackUrl);
      return;
    }
    
    // Hide the image and show placeholder
    event.target.style.display = 'none';
    
    // Hide spinner
    const imageContainer = event.target.closest('.image-container');
    if (imageContainer) {
      const spinner = imageContainer.querySelector('.loading-spinner') as HTMLElement;
      if (spinner) {
        spinner.style.display = 'none';
      }
    }
  }

  onImageLoad(event?: any): void {
    this.imageLoaded = true;
    console.log('✅ Image loaded successfully');
    
    // Hide spinner when image loads
    if (event && event.target) {
      const imageContainer = event.target.closest('.image-container');
      if (imageContainer) {
        const spinner = imageContainer.querySelector('.loading-spinner') as HTMLElement;
        if (spinner) {
          spinner.style.display = 'none';
        }
      }
    }
  }

  trackByFn2(index: number, item: any): any {
    return item.id || index;
  }

  Goto(link: string): void {
    this.album = [];
    this.files = [];
    this.folders = [];
    this.mainResponse = [];
    this.imageLoaded = false;
    this.fetchingData = true;

    this.router.navigateByUrl(`/imageFolder/${link}`);
  }

  selectItem(): void {
    this.router.navigate(["/video-gallery"]);
  }

  // Modal Viewer Functions
  openModal(index: number): void {
    this.currentIndex = index;
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  prevImage(event: Event): void {
    event.stopPropagation();
    if (this.files.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + this.files.length) % this.files.length;
    }
  }

  nextImage(event: Event): void {
    event.stopPropagation();
    if (this.files.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.files.length;
    }
  }

  // UPDATED: Check if album has ANY image
  hasImage(album: any): boolean {
    if (!album) return false;
    
    const allFields = Object.keys(album);
    const hasImage = allFields.some(field => {
      const value = album[field];
      if (!value || typeof value !== 'string') return false;
      
      return (field.toLowerCase().includes('image') || 
              field.toLowerCase().includes('thumb') ||
              field.toLowerCase().includes('path') ||
              field.toLowerCase().includes('link')) &&
             (value.includes('.jpg') || 
              value.includes('.jpeg') || 
              value.includes('.png') || 
              value.startsWith('http') || 
              value.startsWith('dws/'));
    });
    
    console.log(`🔍 hasImage for "${album.Name}":`, hasImage);
    return hasImage;
  }

  // UPDATED: Smart method that finds ANY available image
  getImageUrl(album: any): SafeResourceUrl | string {
    if (!album) {
      return '/assets/img/custom-img.png';
    }
    
    console.log(`🔍 SEARCHING for image in album: "${album.Name}"`);
    console.log('🔍 ALL available fields:', Object.keys(album));
    
    // Get ALL fields that might contain image data
    const allFields = Object.keys(album);
    const imageFields = allFields.filter(field => {
      const value = album[field];
      if (!value || typeof value !== 'string') return false;
      
      // Check if field name suggests it's an image field
      const isImageField = field.toLowerCase().includes('image') || 
                          field.toLowerCase().includes('thumb') ||
                          field.toLowerCase().includes('path') ||
                          field.toLowerCase().includes('link') ||
                          field.toLowerCase().includes('photo') ||
                          field.toLowerCase().includes('pic') ||
                          field.toLowerCase().includes('url');
      
      // Check if value looks like an image URL/path
      const isImageValue = value.includes('.jpg') || 
                          value.includes('.jpeg') || 
                          value.includes('.png') || 
                          value.includes('.webp') ||
                          value.includes('.gif') ||
                          value.startsWith('http') || 
                          value.startsWith('dws/') ||
                          value.includes('/');
      
      return isImageField || isImageValue;
    });
    
    console.log(`🔍 Potential image fields found:`, imageFields);
    console.log(`🔍 Values:`, 
      imageFields.reduce<Record<string, unknown>>((acc, field) => {
        acc[field] = album[field];
        return acc;
      }, {})
    );
    
    // Priority order for image fields
    const priorityOrder = [
      'titleImageLink', 'titleImagePath',
      'thumbnailLink', 'thumbnailPath', 
      'ThumbnailLink', 'ThumbnailPath',
      'ImageLink', 'ImagePath',
      'displayImageUrl'
    ];
    
    // Try fields in priority order
    let imageUrl = null;
    for (let field of priorityOrder) {
      if (imageFields.includes(field) && album[field]) {
        imageUrl = album[field];
        console.log(`✅ Using image from field: ${field}`, imageUrl);
        break;
      }
    }
    
    // If no priority field found, use first available image field
    if (!imageUrl && imageFields.length > 0) {
      imageUrl = album[imageFields[0]];
      console.log(`⚠️ Using first available image field: ${imageFields[0]}`, imageUrl);
    }
    
    if (imageUrl) {
      const finalUrl = this.TransformUrl(imageUrl);
      console.log(`🔗 Final transformed URL:`, finalUrl);
      return finalUrl;
    } else {
      console.log(`❌ No image found for album: "${album.Name}", using fallback`);
      return '/assets/img/custom-img.png';
    }
  }

  // Get object keys for debugging
  getObjectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }
}